import { getCustomerToken } from '../../utils/customerToken';

export const IsLoggedIn = () =>  {
    return !!getCustomerToken();
}